import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=51fcf8a1&scoped=true"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"
import style0 from "./Chart.vue?vue&type=style&index=0&id=51fcf8a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fcf8a1",
  null
  
)

export default component.exports